import React, { Component } from 'react'
import { connect } from 'react-redux'

import { changeTitle } from '../../utils';
import { getProductQuotation } from '../../apiCalls';

import BottomBar from '../../components/coverage/bottom_bar/BottomBar'
import AccordionGroup from '../../components/coverage/accordion/Accordion'
import ModalEmail from '../../components/comparison/modal_email/ModalEmail'
import { openModalQuotationDateWarning } from '../../actions/coverageActions';
import CurrentPurchase from '../../components/coverage/current_purchase/CurrentPurchase'
import ModalQuotationDateWarning from '../../components/common/modal_quotation_date_warning/ModalQuotationDateWarning'


export class Coverage extends Component {
    constructor(props) {
        super(props)

        changeTitle('detail')
        getProductQuotation({ ...props.match.params });
    }

    render() {
        if (this.props.plans.length <= 0)
            return <div />

        return (
            <main>
                <div className="comp_main clearfixs">
                    <CurrentPurchase />

                    <AccordionGroup />

                    <ModalQuotationDateWarning />
                    <ModalEmail type="detail" />
                    <BottomBar />
                </div>
            </main>
        )
    }
}

export default connect(
    state => ({
        plans: state.search.plans,
        productInfo: state.coverage.productInfo,
        productCoverage: state.coverage.productCoverage,
        userDetails: state.comparison.userDetails
    }),
    {
        openModalQuotationDateWarning
    }
)(Coverage)



// WEBPACK FOOTER //
// ./src/views/coverage/Coverage.jsx